import { render, staticRenderFns } from "./AutoServiceCard.vue?vue&type=template&id=1ef98084&scoped=true"
import script from "./AutoServiceCard.vue?vue&type=script&lang=js"
export * from "./AutoServiceCard.vue?vue&type=script&lang=js"
import style0 from "./AutoServiceCard.vue?vue&type=style&index=0&id=1ef98084&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef98084",
  null
  
)

export default component.exports